export default function summaryDisabled(isValid: boolean, isSummaryAccessed: boolean): boolean {
  if (isSummaryAccessed) {
    return !isValid;
  }
  return true;
}
